<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="small">
          <el-form-item label="送货日期：">
            <el-date-picker size="medium" v-model="searchForm.date" type="date" placeholder="选择日期" :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="this.queryTable" style="float:right">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4">
        <el-button size="medium" @click="enterTable">导入</el-button>
        <el-button size="medium" type="primary" plain @click="exportTable">导出</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10">
        <span>{{ this.name }}</span>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px">
      <el-col :data="tableData" v-for="item in tableData" :key="item.INCOME_DATE">
        <table cellpadding="0" cellspacing="0" style="width:100%" class="sending">
          <caption class="table-title" style="">{{ item.CNAME }}</caption>
          <tr style="width:100%">
            <td style="width:100%">
              <table cellpadding="0" cellspacing="0" style="width:100%">
                <tr class="table-line">
                  <td class="product-title" style="width:30%">品名</td>
                  <td class="product-title" style="width:100px;text-align:center">单位</td>
                  <td class="product-title" style="width:30%;text-align:center">分量</td>
                  <td class="product-title" style="width:10%;text-align:center">总量</td>
                  <td class="product-title" style="width:100px;text-align:center">单价</td>
                  <td class="product-title" style="width:10%;text-align:center">合计</td>
                </tr>
                <tr class="table-line">
                  <td class="product-title" style="width:30%">品名</td>
                  <td class="product-title" style="width:100px;text-align:center">单位</td>
                  <td class="product-title" style="width:30%;text-align:center">分量</td>
                  <td class="product-title" style="width:10%;text-align:center">总量</td>
                  <td class="product-title" style="width:100px;text-align:center">单价</td>
                  <td class="product-title" style="width:10%;text-align:center;border:0">合计</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr class="table-line" v-for="index in item.DATA" :key="index.INCOME_DATE">
            <td class="product" style="width:30%;">{{ index.N }}</td>
            <td class="product" style="width:100px;text-align:center">{{ index.D }}</td>
            <td class="product" style="width:30%;text-align:center">{{ index.U }}</td>
            <td class="product" style="width:10%;text-align:center">{{ index.T }}</td>
            <td class="product" style="width:100px;text-align:center">{{ index.P }}</td>
            <td class="product" style="width:10%;text-align:center">{{ index.W }}</td>
          </tr>
          <tr style="width:100%">
            <td style="width:100%">
              <table cellpadding="0" cellspacing="0" style="width:100%">
                <tr class="table-line">
                  <td class="product-title" style="width:90.1%">总计</td>
                  <td class="product-title" style="width:100px;text-align:center">{{ item.SUM }}</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-dialog title="上传成本数据" center :visible.sync="addFormVisible" width="600px">
      <el-form ref="addForm" v-model="addForm">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
          :on-remove="handleRemove" :name="this.addForm.price" multiple accept=".xls, .xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitEnter">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { shopPriceFun, importShopPriceFun, exportShopPriceFun } from 'api/shopPrice';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      searchForm: {
        date: date(new Date(), '%F'),
      },
      tableData: [],
      addForm: {
        price: 'tmp',
      },
      fileList: [],
      addFormVisible: false,
      file_name: '',
      name: '',
      loading: false,
      // loading1: false
    };
  },
  created() {
    this.queryTable();
  },
  methods: {
    // ---------------------------拉取数据
    queryTable() {
      const params = {};
      if (this.searchForm.date) {
        params.SEND_DAY = date(this.searchForm.date, '%F');
      }
      shopPriceFun(params)
        .then((result) => {
          this.name = result[0].COMPANY_NAME;
          if (result[0].DATA.length !== 0) {
            this.tableData = result[0].DATA;
          } else {
            this.tableData = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // ---------------------------------导出
    exportTable() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          // this.loading1 = true
          const params = {
            SEND_DAY: date(this.searchForm.date, '%F'),
          };
          exportShopPriceFun(params)
            .then((result) => {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              // this.loading1 = false
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              // this.loading1 = false
              document.body.style.cursor = 'default';
            });
        } finally {}
      }
    },
    enterTable() {
      this.addFormVisible = true;
    },
    close(formName) {
      this.addFormVisible = false;
      this.fileList = [];
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    // ------------------------------------导入采购价
    submitEnter() {
      if (!this.file_name) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            FILE_NAME: this.file_name,
          };
          if (this.searchForm.date) {
            params.SEND_DAY = date(this.searchForm.date, '%F');
          }
          importShopPriceFun(params)
            .then((result) => {
              this.queryTable();
              this.$message.show({ text: '操作成功', type: 'success' });
              this.addFormVisible = false;
              this.fileList = [];
              this.file_name = '';
              this.$refs.upload.clearFiles();
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              this.fileList = [];
              this.file_name = '';
              this.$refs.upload.clearFiles();
              document.body.style.cursor = 'default';
            });
        } finally {}
      }
    },
  },
};
</script>
<style scoped>
.product {
  color: #606266;
  padding-left: 5px;
  height: 40px
}

.table-title {
  height: 50px;
  line-height: 50px;
  border: 1px solid #ebeef5;
  color: #909399;
  font-weight: bold;
  border-bottom: 0
}

.table-line {
  float: left;
  width: 50%;
  border-bottom: 0px
}

.sending,
.sending tr th,
.sending tr td {
  border: 1px solid #ebeef5;
}

.product-title {
  border-top: 0 !important;
  border-bottom: 0 !important;
  color: #606266;
  padding-left: 5px;
  height: 40px
}
</style>



// WEBPACK FOOTER //
// src/components/costCenter/shopPrice.vue